import {RosterViewSettings} from '@/types';
import {RosterData, NullableDateRange} from '@/types/types';
import RosterConverter from '@/util/rosterconverter';
import {ApiClient, Roster, Company, Organisation, Shift} from '@cquential/api';
import Dates from '@cquential/date-utils';
import GlobalErrorModal from '@/components/modals/GlobalErrorModal.vue';

export default class RosterLoader {
    public static load(rosterViewSettings: RosterViewSettings, showPlusMinusBalanceFrom: Date | false, companies: Company[], organisation: Organisation, shifts: Record<number, Shift>): Promise<RosterData> {
        const plusMinusRange: NullableDateRange = {
            end: Dates.Utils.addDays(rosterViewSettings.startDate, rosterViewSettings.visibleDays - 1),
        };
        if (showPlusMinusBalanceFrom && showPlusMinusBalanceFrom <= rosterViewSettings.startDate) {
            plusMinusRange.begin = new Date(showPlusMinusBalanceFrom);
        }

        return ApiClient.instance.fetchRoster(rosterViewSettings.rosterId, rosterViewSettings.startDate, rosterViewSettings.visibleDays,
            [
                'allowedFunctions',
                'budgets.amounts',
                'comments.rosterIds',
                'companyDeployments.companyEmployee',
                'companyDeployments.specifications',
                'holidays',
                'openShifts.applications',
                'openShifts.publishedToOtherCompanies',
                'openShifts.specifications',
                'secondaryPage',
                'timeTypes',
                'rosterRankSets.titles',
                'rosterRankSets.resourceRosterRanks',
                'resources.atwIssues',
                'resources.balances',
                'resources.assignedDays',
                'resources.contractedTimes',
                'resources.deployments.positionAssignmentSetGroupPositionDeployments',
                'resources.deployments.specifications',
                'resources.deploymentProposals.specifications',
                'resources.employment.user',
                'resources.employment.comment',
                'resources.employment.commentsByDate',
                'resources.functions',
                'resources.leavePeriodsFromForms',
                'resources.leavePeriods',
                'resources.personalPlanningWishes',
                'resources.personalStamps.personalStampShifts',
                'resources.personalStamps.personalStampAssignedDays',
                'resources.rosterAssignments',
                'resources.sickPeriods.percentages',
                'resources.unavailabilities',
                'resourcesFromOtherRosters.assignedDays',
                'resourcesFromOtherRosters.contractedTimes',
                'resourcesFromOtherRosters.deployments.positionAssignmentSetGroupPositionDeployments',
                'resourcesFromOtherRosters.deployments.specifications',
                'resourcesFromOtherRosters.deploymentProposals.specifications',
                'resourcesFromOtherRosters.employment.user',
                'resourcesFromOtherRosters.employment.comment',
                'resourcesFromOtherRosters.employment.commentsByDate',
                'resourcesFromOtherRosters.functions',
                'resourcesFromOtherRosters.leavePeriodsFromForms',
                'resourcesFromOtherRosters.leavePeriods',
                'resourcesFromOtherRosters.personalPlanningWishes',
                'resourcesFromOtherRosters.personalStamps.personalStampShifts',
                'resourcesFromOtherRosters.personalStamps.personalStampAssignedDays',
                'resourcesFromOtherRosters.rosterAssignments',
                'resourcesFromOtherRosters.sickPeriods.percentages',
                'resourcesFromOtherRosters.unavailabilities',
                'relatedResources.assignedDays',
                'relatedResources.contractedTimes',
                'relatedResources.deployments.positionAssignmentSetGroupPositionDeployments',
                'relatedResources.deployments.specifications',
                'relatedResources.deploymentProposals.specifications',
                'relatedResources.employment.user',
                'relatedResources.employment.comment',
                'relatedResources.employment.commentsByDate',
                'relatedResources.functions',
                'relatedResources.leavePeriodsFromForms',
                'relatedResources.leavePeriods',
                'relatedResources.personalPlanningWishes',
                'relatedResources.personalStamps.personalStampShifts',
                'relatedResources.personalStamps.personalStampAssignedDays',
                'relatedResources.sickPeriods.percentages',
                'relatedResources.unavailabilities',
                'workloadRequirements',
            ],
            plusMinusRange.begin,
            plusMinusRange.end)
            .then((roster: Roster): RosterData => {
                return RosterConverter.convertRoster(roster, rosterViewSettings.rosterId, rosterViewSettings.startDate, rosterViewSettings.visibleDays, organisation, companies, shifts);
            })
            /** @see GlobalErrorModal.globalErrorHandler() */
            // @ts-expect-error TS2339
            .catch(GlobalErrorModal.__vfdConstructor.globalErrorHandler);
    }
}
